import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

// DESIGN.md component: sticker. A small decorative text badge: neon fill,
// charcoal text, slight tilt. Never holds an amount, a fee, a warning or an
// action.
export function Sticker({ children, tilt = "r", className }: { children: ReactNode; tilt?: "l" | "r"; className?: string }) {
  return (
    <span
      className={cn(
        "inline-block rounded-zsd-full bg-zsd-primary text-zsd-on-primary px-zsd-sm py-zsd-xs",
        "font-zsd-label-md text-zsd-label-md uppercase",
        tilt === "l" ? "tilt-l" : "tilt-r",
        className,
      )}
    >
      {children}
    </span>
  );
}
